import { computed, ref, type Ref } from "vue";

type ViewportRefs = {
  isPhoneViewport: Ref<boolean>;
  isTabletViewport: Ref<boolean>;
  isDesktopViewport: Ref<boolean>;
};

export function useProductOverlays(
  viewport: ViewportRefs,
  hasProductReviews: Ref<boolean>
) {
  const isPaymentInfoSidebarOpen = ref(false);
  const isReviewsSidebarOpen = ref(false);
  const isPaymentSheetOpen = ref(false);
  const isReviewsSheetOpen = ref(false);

  const closePaymentSheet = () => {
    isPaymentSheetOpen.value = false;
  };

  const closeReviewsSheet = () => {
    isReviewsSheetOpen.value = false;
  };

  const closePaymentInfoSidebar = () => {
    isPaymentInfoSidebarOpen.value = false;
  };

  const closeReviewsSidebar = () => {
    isReviewsSidebarOpen.value = false;
  };

  const openPaymentSheet = () => {
    if (!viewport.isPhoneViewport.value) return;

    isPaymentInfoSidebarOpen.value = false;
    closeReviewsSidebar();
    closeReviewsSheet();
    isPaymentSheetOpen.value = true;
  };

  const openReviewsSheet = () => {
    if (!viewport.isPhoneViewport.value) return;

    isReviewsSidebarOpen.value = false;
    closePaymentInfoSidebar();
    closePaymentSheet();
    isReviewsSheetOpen.value = true;
  };

  const openPaymentInfo = () => {
    closeReviewsSidebar();
    closeReviewsSheet();

    if (viewport.isPhoneViewport.value) {
      openPaymentSheet();
      return;
    }

    closePaymentSheet();
    isPaymentInfoSidebarOpen.value = true;
  };

  const openReviewsOverlay = () => {
    if (!hasProductReviews.value) {
      return;
    }

    closePaymentInfoSidebar();
    closePaymentSheet();

    if (viewport.isPhoneViewport.value) {
      openReviewsSheet();
      return;
    }

    closeReviewsSheet();
    isReviewsSidebarOpen.value = true;
  };

  const syncOverlaysOnResize = () => {
    if (viewport.isPhoneViewport.value) {
      isPaymentInfoSidebarOpen.value = false;
      isReviewsSidebarOpen.value = false;
      return;
    }

    if (isPaymentSheetOpen.value) {
      closePaymentSheet();
    }

    if (isReviewsSheetOpen.value) {
      closeReviewsSheet();
    }
  };

  const isPaymentSidebarOpen = computed(
    () =>
      (viewport.isTabletViewport.value || viewport.isDesktopViewport.value) &&
      isPaymentInfoSidebarOpen.value
  );

  const isReviewsSidebarOpenState = computed(
    () =>
      (viewport.isTabletViewport.value || viewport.isDesktopViewport.value) &&
      isReviewsSidebarOpen.value
  );

  return {
    isPaymentInfoSidebarOpen,
    isReviewsSidebarOpen,
    isPaymentSheetOpen,
    isReviewsSheetOpen,
    isPaymentSidebarOpen,
    isReviewsSidebarOpenState,
    closePaymentInfoSidebar,
    closeReviewsSidebar,
    openPaymentInfo,
    openReviewsOverlay,
    syncOverlaysOnResize,
  };
}
